import { GoogleMaps } from "./GoogleMaps";
/**
 * Simple factory for creating diferent functionalities of maps
 */

export class MapFactory {
  static createMap(type, options) {
    switch (type) {
      case 'google':
        return GoogleMaps.create(options);
    }
  }

}
//# sourceMappingURL=MapFactory.js.map